export type DeviceStatusFilter = 'active' | 'inactive'

export type DeviceFilters = {
  serial_number: string
  location: string
  status?: DeviceStatusFilter
}

export const emptyDeviceFilters = (): DeviceFilters => ({
  serial_number: '',
  location: '',
  status: undefined,
})
